import vue from 'vue';
import Router from 'vue-router';
import ls from '../localstorage';
import store from '../store';

// Authentication Pages
const AuthPage = () => import("@/views/Auth/AuthPage");
const Login = () => import("@/views/Auth/Login");
const Callback = () => import("@/views/Auth/callback");
const Resetpassword = () => import("@/views/Auth/resetpassword");


const Home = () => import("@/views/Dashboard/Index");
const HomeDefaultPage = () => import("@/views/Dashboard/Home");
const Newsfeeds = () => import("@/components/Home/NewsFeed");
const BusinessToFollow = () => import("@/components/Home/BusinessToFollow");
const related_deals = () => import("@/components/Home/deals/related_deals");
const deal_page = () => import("@/components/Home/deals/deal_page");
const recommended_hotels = () => import("@/components/Home/recommended_hotels");
const livescores = () => import("@/views/Livescores/index");
const livescoresMatch = () => import("@/views/Livescores/match");
const Tweets = () => import("@/views/Tweets/index");

// Notifications
const NotificationsPage = () => import("@/views/Notifications/index");

// profile
const ProfileLayout = () => import("@/views/Profile/Index");
const Profile = () => import("@/views/Profile/Default");
const AccountInfo = () => import("@/views/Profile/AccountInfo");
const PasswordChange = () => import("@/views/Profile/PasswordChange");

// matches
const Match = () => import("@/views/Match/Index");

const About = () => import("@/views/About/Index");

// deals
const Deals = () => import("@/views/Deals/Index");

// special pages
const Kits = () => import("@/views/Special/Kits/Index");
const Restaurants = () => import("@/views/Special/Restaurants/Index");
const Odds = () => import("@/views/Special/Odds/Index");
const Hotels = () => import("@/views/Special/Hotels/index");
const Travel = () => import("@/views/Special/Travel/index");
const SpecialHome = () => import("@/views/Special/index");

const NotFound = () => import("@/views/404/404.vue");
// response message
const ResponseMessage = () => import("@/components/ResponseMessage");
const Notifications = () => import("@/components/Notifications");
const Internet = () => import("@/components/Internet");

// logout
const Logout = () => import("@/components/Logout");

// terms
const Termsandconditions = () => import("@/views/Terms/Termsandconditions");
const CommunityRules = () => import("@/views/Terms/communityRules");

import offline from 'v-offline';

vue.use(Router);
vue.component("response-message", ResponseMessage);
vue.component("notification", Notifications);
vue.component("offline", offline);
vue.component("internet", Internet);

const SpinnerLoader = () => import("@/components/Loaders/Spinners");
vue.component("spinner", SpinnerLoader);

let fansData = false;
let data = {};
if (ls.checkStorage("fansData")) {
    data = ls.getStorage("fansData");
    data = data[0];
    fansData = true;
}

const router = new Router({
    mode: "history",
    scrollBehavior() {
        return { x: 0, y: 0 };
    },

    routes: [
        {
            path: "/auth",
            name: "AuthPage",
            component: AuthPage,
            children: [
                {
                    path: "login",
                    name: "Login",
                    component: Login,
                    meta: {
                        title: 'Login Matchdaydeals',
                        metaTags: [
                            {
                                name: 'description',
                                content: 'Login to access more features of Matchday.ng',
                            },
                        ],
                    },
                },
                {
                    path: "callback",
                    name: "Callback",
                    component: Callback,
                },
                {
                    path: "resetpassword/:token",
                    props: true,
                    name: "Reset_password",
                    component: Resetpassword,
                },
                // {
                //     path: "logout",
                //     name: "Logout",
                //     component: Logout
                // }
            ],
        },
        {
            path: "/",
            component: Home,
            children: [
                {
                    path: "/",
                    name: "HomeDefaultPage",
                    component: HomeDefaultPage,
                    children: [
                        {
                            path: "/",
                            name: "NewsFeed",
                            component: Newsfeeds,
                            meta: {
                                title: 'Home',
                            },
                        },
                        {
                            path: "businesstofollow",
                            name: "BusinessToFollow",
                            component: BusinessToFollow,
                            meta: {
                                title: 'Business - Matchdaydeals',
                                metaTags: [
                                    {
                                        name: 'description',
                                        content: 'List of Businesses on Matchdaydeals to follow',
                                    },
                                ],
                            },
                        },
                        {
                            path: "related_deals",
                            name: "related_deals",
                            component: related_deals,
                        },
                        {
                            path: "related_deals/:deal_id",
                            name: "deal_page",
                            props: true,
                            component: deal_page,
                        },
                        {
                            path: "recommended_hotels",
                            name: "recommended_hotels",
                            component: recommended_hotels,
                        },
                        {
                            path: "profile/:username",
                            props: true,
                            name: "Profile",
                            meta: {
                                title: 'Profile',
                                authRequired: true,
                            },
                            component: Profile,
                        },
                        {
                            path: "/:username/reviews/:tweet_slug",
                            props: true,
                            name: "Review",
                            meta: {
                                title: 'Review',
                                authRequired: true,
                            },
                            component: Tweets,
                        },
                        {
                            path: "notifications",
                            props: true,
                            name: "Notifications",
                            meta: {
                                title: 'Notifications',
                                authRequired: true,
                            },
                            component: NotificationsPage,
                        },
                        {
                            path: "settings/",
                            name: "Settings",
                            meta: {
                                authRequired: true,
                            },
                            component: ProfileLayout,
                            children: [
                                {
                                    path: "accountinfo",
                                    name: "AccountInfo",
                                    meta: {
                                        title: 'Account Info',
                                        authRequired: true,
                                    },
                                    component: AccountInfo,
                                },
                                {
                                    path: "/passwordchange",
                                    name: "PasswordChange",
                                    meta: {
                                        title: 'Password Change',
                                        authRequired: true,
                                    },
                                    component: PasswordChange,
                                },
                            ],
                        },
                        {
                            path: "/match/:fixture_id",
                            props: true,
                            meta: {
                                title: 'Matches',
                            },
                            name: "Match",
                            component: Match,
                        },
                        {
                            path: "livematch",
                            name: "Livematch",
                            meta: {
                                title: "Livematch",
                            },
                            component: livescores,
                        },
                        {
                            path: "livematch/:match_id",
                            name: "LivescoresMatch",
                            meta: {
                                title: "livematch",
                            },
                            component: livescoresMatch,
                        },
                        {
                            path: "/terms",
                            name: "Terms",
                            meta: {
                                title: "Terms and Conditions",
                            },
                            component: Termsandconditions,
                        },
                        {
                            path: "/community_rules",
                            name: "Community_rules",
                            meta: {
                                title: "Community Rules",
                            },
                            component: CommunityRules,
                        },
                        {
                            path: "/r/:username",
                            name: "Referral",
                            component: Newsfeeds,
                            meta: {
                                referral: true,
                                title: 'Newsfeeds',
                            },
                        },
                    ],
                },
            ],
        },
        {
            path: "*",
            name: "404",
            component: NotFound,
        },
        {
            path: "/logout",
            name: "logout",
            component: Logout,
        },
    ],
})

router.beforeEach((to, from, next) => {

    if (to.matched.some(record => record.meta.referral)) {
        window.eventBus.$emit('openAuthModal', true)
        store.state.isFromReferral = true
    }

    const $metaTitle = to.matched.some(r => r.meta.title);
    const $mTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title);
    if ($mTitle) {
        const notifications = store.getters.getNotifications
        if (notifications.total) {
            const $count = notifications.total
            const combineTitle = ` (${$count}) ${$mTitle.meta.title} / ${store.state.projectName}`
            document.title = combineTitle;
        }else {
            const combineTitle = `${$mTitle.meta.title} / ${store.state.projectName}`
            document.title = combineTitle;
        }
    }

    if (to.matched.some(record => record.meta.businessRequired)) {
        if (data.user_type !== '2' ) {
            next({
                path: '/',
                query: { redirect: to.fullPath },
            })
        }else {
            next()
        }
    } else {
        next()
    }
  if (to.matched.some(record => record.meta.authRequired)) {
    if (!fansData) {
      next({
        path: '/',
        query: { redirect: to.path },
      })
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router
